import { cmsRoutes, routes } from '@shared/constants/routes'
import { type Hyperlink } from '@/features/shared/constants/hyperlinks'

export const MEMBERSHIP_POPOVER_LINKS = [
  { url: routes.PRICING.url, name: 'See all plans' },
  { url: routes.STUDENT.url, name: 'Student Membership' },
  {
    url: 'https://www.shipt.com/lp/snap/',
    name: 'SNAP EBT Membership',
  },
  {
    url: 'https://www.shipt.com/gift/',
    name: 'Gift Cards',
  },
] as const satisfies Hyperlink[]

export const SAME_DAY_DELIVERY_LINKS = [
  { url: cmsRoutes.DELIVERY.GROCERY_DELIVERY, name: 'Grocery delivery' },
  { url: cmsRoutes.DELIVERY.ALCOHOL_DELIVERY, name: 'Alcohol delivery' },
  {
    url: cmsRoutes.DELIVERY.PET_SUPPLIES_DELIVERY,
    name: 'Pet supplies delivery',
  },
  {
    url: cmsRoutes.DELIVERY.ELECTRONICS_DELIVERY,
    name: 'Electronics delivery',
  },
  {
    url: cmsRoutes.DELIVERY.HOUSEHOLD_ESSENTIALS_DELIVERY,
    name: 'Household essentials delivery',
  },
  { url: cmsRoutes.DELIVERY.SEASONAL_DELIVERY, name: 'Seasonal delivery' },
  { url: cmsRoutes.DELIVERY.ALCOHOL_DELIVERY_NEAR_YOU, name: 'Alcohol delivery near you' },
  { url: routes.DELIVERY.url, name: 'View all' },
] as const satisfies Hyperlink[]
